import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasLeganes() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Leganés, Madrid</h1>
        <span className={styles.lastUpdated}>Mudanzas profesionales en Leganés con el mejor precio del sur de Madrid</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/distrito-leganes.webp"
            alt="Mudanzas en Leganés"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          Si necesitas una <strong>mudanza en Leganés</strong>, Britosa Mudanzas es tu mejor opción. Con más de 25 años de experiencia y sede a escasos minutos en Móstoles, ofrecemos un servicio rápido, económico y de máxima calidad en todo el municipio de Leganés.
        </p>

        <h2>¿Por qué elegir Britosa en Leganés?</h2>
        <p>
          Leganés es una de las ciudades con mayor densidad poblacional del sur de Madrid, lo que implica una alta demanda de servicios de mudanza. Nuestro equipo conoce cada barrio, cada calle y cada particularidad de las viviendas de la zona, desde los bloques del centro hasta las casas adosadas de las zonas residenciales.
        </p>
        <ul>
          <li>Presupuestos cerrados y sin sorpresas.</li>
          <li>Seguro a todo riesgo incluido.</li>
          <li>Equipo propio, nunca subcontratamos.</li>
          <li>Disponibles todos los días de 8:00 a 22:00.</li>
          <li>Montacargas portátil para plantas altas sin ascensor.</li>
        </ul>

        <h2>Servicios en Leganés</h2>
        <ul>
          <li><strong>Mudanzas locales:</strong> Dentro de Leganés o hacia Madrid, Móstoles, Alcorcón, Getafe y Fuenlabrada.</li>
          <li><strong>Mudanzas familiares:</strong> Pisos de 1 a 5 dormitorios con embalaje completo.</li>
          <li><strong>Mudanzas de oficinas:</strong> Traslados de empresas con mínima interrupción.</li>
          <li><strong>Guardamuebles:</strong> Almacenaje temporal seguro y climatizado.</li>
          <li><strong>Montaje de muebles:</strong> Desmontaje en origen y montaje en destino.</li>
        </ul>

        <h2>Zonas de Leganés</h2>
        <p>
          Centro, San Nicasio, Zarzaquemada, Arroyo Culebro, Polvoranca, Butarque, El Carrascal, La Fortuna, Parque de la Hispanidad y todos los barrios del municipio.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Tu mudanza en Leganés empieza aquí</h3>
          <p style={{ marginBottom: "1rem" }}>
            Presupuesto gratis en menos de 24h. Sin compromiso.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          <a href="tel:+34691604880">691 60 48 80</a> · Todos los días 8:00 – 22:00
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Leganés",
          "description": "Mudanzas profesionales en Leganés, Madrid. Mejor precio del sur de Madrid.",
          "url": "https://mudanzasbritosa.com/mudanzas-leganes",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero, 28934 Móstoles",
            "addressLocality": "Leganés, Madrid",
            "addressRegion": "Madrid",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.3272,
            "longitude": -3.7635
          },
          "areaServed": {
            "@type": "City",
            "name": "Leganés"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );
}
